import { PAGE_DATA_MODIFIED_MUTATION } from '../mutation-types';
export const namespaced = true;
export const state = {
    namespaced: true,
    isDataModified: false
};

export const actions = {

};

export const mutations = {
    [PAGE_DATA_MODIFIED_MUTATION] (state, isDataModified) {
        state.isDataModified = isDataModified;
    }
};